// Helper to convert a filters object from the Filters component into query params
export function buildParams(filters = {}) {
  // input received from Filters component
  const params = {};
  // Determine deepest selected category id and name (if provided)
  let catId = filters.category;
  if (filters.category_child1) catId = filters.category_child1;
  if (filters.category_child2) catId = filters.category_child2;

  let catName = '';
  if (filters.category_child2_name) catName = filters.category_child2_name;
  else if (filters.category_child1_name) catName = filters.category_child1_name;
  else if (filters.categoryName) catName = filters.categoryName;

  // Prefer sending categoryId (IDs are now primary since decoupling).
  // Fall back to category names for legacy support/URL readability if ID is missing.
  if (catId && !isNaN(catId)) {
    params.categoryId = Number(catId);
  } else if (catName) {
    params.category = catName;
  } else if (catId) {
    params.category = catId;
  }
  if (filters.offer) params.offer = true;
  if (filters.isNew) params.isNew = true;
  // Support brand as array or comma-separated string
  if (filters.brand) {
    if (Array.isArray(filters.brand)) {
      if (filters.brand.length) params.brand = filters.brand.slice();
    } else if (typeof filters.brand === 'string') {
      const s = filters.brand.trim();
      if (s.includes(',')) params.brand = s.split(',').map(x => x.trim()).filter(Boolean);
      else if (s !== '') params.brand = s;
    }
  }
  if (filters.priceMin) params.priceMin = filters.priceMin;
  if (filters.priceMax) params.priceMax = filters.priceMax;
  if (filters.warranty) params.warranty = filters.warranty;
  // Support multi-select specs via `filters.specs` object: { specKey: ['v1','v2'] }
  if (filters.specs && typeof filters.specs === 'object') {
    Object.entries(filters.specs).forEach(([k, v]) => {
      if (v === undefined || v === null || v === '') return;
      if (Array.isArray(v)) {
        if (v.length) params[`spec_${k}`] = v.slice();
      } else {
        params[`spec_${k}`] = v;
      }
    });
  } else if (filters.specKey && filters.specValue) {
    params[`spec_${filters.specKey}`] = filters.specValue;
  }
  if (filters.ratingMin) params.ratingMin = filters.ratingMin;

  // return built params
  return params;
}

const filterService = { buildParams };
export default filterService;
